import { format } from 'date-fns';

export const formatDateString = (date: string) => {
  return format(new Date(date), 'dd.MM.yyyy');
};
